import React, { forwardRef, PropsWithChildren } from 'react'

import styles from './SinglePostWrap.module.scss'

export const SinglePostWrap = forwardRef<HTMLDivElement, PropsWithChildren>(({ children, ...props }, ref) => (
  <div className={styles.singlePostWrap} ref={ref} {...props}>
    {children}
  </div>
))
